import Script from "next/script";
import { useEffect } from "react";

interface TrustpilotCarouselProps {
  includeRichSnippet?: boolean;
  useSelectedReviews?: boolean;
  type?: "slider" | "carousel";
}

const TrustpilotCarousel = ({
  includeRichSnippet,
  useSelectedReviews,
  type = "carousel",
}: TrustpilotCarouselProps) => {
  useEffect(() => {
    if ((window as any).Trustpilot) {
      const trustbox = document.getElementById("trustbox");
      (window as any).Trustpilot.loadFromElement(trustbox);
    }
  }, []);

  let dataTemplateId;
  let dataStyleHeight;
  switch (type) {
    case "slider":
      dataTemplateId = "54ad5defc6454f065c28af8b";
      dataStyleHeight = "240px";
      break;
    default:
      dataTemplateId = "53aa8912dec7e10d38f59f36";
      dataStyleHeight = "140px";
  }

  return (
    <div>
      <Script
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="lazyOnload"
      />
      <div style={{ margin: "auto", maxWidth: 1140, padding: "36px 0" }}>
        <div style={{ marginTop: 16 }}>
          <div
            id="trustbox"
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id={dataTemplateId}
            data-businessunit-id="5c0aad580b068b0001e14acb"
            data-style-height={dataStyleHeight}
            data-style-width="100%"
            data-theme="light"
            data-stars="3,4,5"
            data-tags={useSelectedReviews ? "feature" : undefined}
            data-schema-type={includeRichSnippet ? "Organization" : undefined}
          >
            <a
              href="https://www.trustpilot.com/review/jerseywatch.com"
              target="_blank"
              rel="noreferrer"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustpilotCarousel;
